import { getPlan } from '../services/subscription.service'
import { Plan, Plans } from './Plan'

export interface DBSubscription {
  active: boolean;
  current_period_end: number;
  subscriptionId: string;
  planId: keyof Plans;
  status?: 'active' | 'canceled';
  cancel_at_period_end?: boolean;
}

export interface Subscription extends DBSubscription {
  plan: Plan;
  expiring: boolean;
  expired: boolean;
  exists: boolean;
}

export const Subscription = (dbSubscription?:  DBSubscription): Subscription => {
  const active = Boolean(dbSubscription?.active)
  const expired = dbSubscription?.current_period_end ? dbSubscription.current_period_end * 1000 < new Date().getTime() : true
  const expiring = !active && !expired
  const planId = active || !active && !expired ? dbSubscription?.planId || 'FREE' : 'FREE'
  const plan = getPlan(planId)
  return {
    exists: Boolean(dbSubscription),
    active: active,
    subscriptionId: dbSubscription?.subscriptionId || '',
    planId: planId,
    plan: plan,
    expiring: expiring,
    current_period_end: dbSubscription?.current_period_end || 0,
    expired: expired
  }
}